import { SectionTitle } from '../../ui';
import { FeatureCard } from './FeatureCard';
import { features } from '../../../data';

export function WhyUs() {
    return (
        <section className="py-12 md:py-16 bg-blue-900">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <SectionTitle subtitle="Motivele pentru care clientii ne aleg" className="text-white [&>h2]:text-white [&>p]:text-white/80">De ce sa ne alegeti?</SectionTitle>

                <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                    {features.map((feature) => (
                        <FeatureCard
                            key={feature.id}
                            icon={feature.icon}
                            title={feature.title}
                            description={feature.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
